import {createSlice} from '@reduxjs/toolkit';
type User={
    user: string;
    username?:string,
    password?:string
}

export const userSlice = createSlice({

    name: 'user',
    initialState: {username: '',password:''},
    reducers: {
        Username: (state, action) => {
            state.username = action.payload
        },
        Password: (state, action) => {
            state.password = action.payload
        }
    }
});

export const userActions = userSlice.actions;
export const selectUser = (state:User) => state.user;
export default userSlice.reducer

